export const FETCH_ARTICLES_PROJEKTE_REQUEST =
    'FETCH_ARTICLES_PROJEKTE_REQUEST';
export const FETCH_ARTICLES_PROJEKTE_SUCCESS =
    'FETCH_ARTICLES_PROJEKTE_SUCCESS';
export const FETCH_ARTICLES_PROJEKTE_FAILURE =
    'FETCH_ARTICLES_PROJEKTE_FAILURE';
export const FETCH_ARTICLES_PROJEKTE_CLEAN_UP =
    'FETCH_ARTICLES_PROJEKTE_CLEAN_UP';
export const UPDATE_PROJEKTE_PAGE_START_PARAM =
    'UPDATE_PROJEKTE_PAGE_START_PARAM';
